import React, { useState } from "react";
import "./Modals.css";

export function RadiusModal({ isVisible, onConfirm, onCancel }) {
  const [radius, setRadius] = useState("");

  const handleConfirm = () => {
    const radiusValue = parseFloat(radius);
    if (radiusValue > 0) {
      onConfirm(radiusValue);
      setRadius("");
    }
  };

  return (
    <div className={`modal-container ${isVisible ? "" : "hidden"}`}>
      <div className="modal-content">
        <h3>Enter Radius</h3>
        <p>Specify the circle radius in meters.</p>
        <input
          type="number"
          className="modal-input"
          placeholder="e.g., 500"
          min="1"
          value={radius}
          onChange={(e) => setRadius(e.target.value)}
          autoFocus={isVisible}
        />
        <div className="modal-actions">
          <button className="modal-cancel-btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="modal-confirm-btn" onClick={handleConfirm}>
            Create Circle
          </button>
        </div>
      </div>
    </div>
  );
}

export function ClearModal({ isVisible, onConfirm, onCancel }) {
  return (
    <div className={`modal-container ${isVisible ? "" : "hidden"}`}>
      <div className="modal-content">
        <h3>Confirm Clear</h3>
        <p>
          Are you sure you want to delete all drawings? This action cannot be
          undone.
        </p>
        <div className="modal-actions">
          <button className="modal-cancel-btn" onClick={onCancel}>
            Cancel
          </button>
          <button
            id="clear-confirm-btn"
            className="modal-confirm-btn"
            onClick={onConfirm}
          >
            Yes, Clear All
          </button>
        </div>
      </div>
    </div>
  );
}
